/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { FileCard } from '@atlassian/conversation-assistant-chat-prompt-input/ui/file-card';
import { type MessageFileId } from '@atlassian/conversation-assistant-service-api/types/assistance-service';

import { useFileThumbnails } from '../../../../../common/hooks/useFileThumbnails';

const styles = cssMap({
	listWrapper: {
		display: 'flex',
		flexWrap: 'wrap',
		alignItems: 'start',
		justifyContent: 'flex-end',
		gap: token('space.050'),
		listStyle: 'none',
		margin: 0,
		padding: 0,
		paddingBlockEnd: token('space.050'),
	},
});

type FileListDisplayProps = {
	files: MessageFileId[];
};

export const FileListDisplay = ({ files }: FileListDisplayProps): JSX.Element => {
	const { blobUrls, isLoading, fileObjects } = useFileThumbnails(files);

	return (
		<Box as="ul" xcss={styles.listWrapper}>
			{files.map((file) => {
				return (
					<Box as="li" key={file.id}>
						<FileCard
							fileName={file.name}
							previewBlobUrl={file.id ? blobUrls[file.id] : undefined}
							isPreviewLoading={file.id ? isLoading[file.id] : false}
							fileObject={file.id ? fileObjects[file.id] : undefined}
						/>
					</Box>
				);
			})}
		</Box>
	);
};
